import type { ISettingsProvider } from '@paperbits/common/configuration';
import * as config from 'config.tamtamy.json';

// copied from @paperbits/common because fuck you webpack
function getObjectAt<T>(path: string, source: object): T {
    const segments = path.split('/');
    let segmentObject = source;

    for (const segment of segments) {
        segmentObject = segmentObject[segment];

        if (segmentObject === null || segmentObject === undefined) {
            return <any>segmentObject;
        }
    }

    return <any>segmentObject;
}

const error = 'Configurations are final and cannot be set.';

export class BundledSettingsProvider implements ISettingsProvider {

    private readonly config: object;

    constructor(config: any) {
        this.config = config.default ?? config; // hack
    }

    public static newInstance(): BundledSettingsProvider {
        return new BundledSettingsProvider(config);
    }

    public async getSetting<T>(name: string): Promise<T> {
        return this.getSettingSync<T>(name);
    }

    public getSettingSync<T>(name: string): T {
        return getObjectAt(name, this.config);
    }

    public onSettingChange<T>(_name: string, _eventHandler: (value: T) => void): void {
        throw new Error(error);
    }

    public async setSetting<T>(_name: string, _value: T): Promise<void> {
        throw new Error(error);
    }

    public async getSettings(): Promise<any> {
        return this.config;
    }
}